/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     费用中心数据管理
  +--------------------------------------------------------------------------------------
*/

const expenseStore = {
  state: {
    orderTypeArr: [
      { value: 1, title: '新购' },
      { value: 2, title: '续费' },
      { value: 3, title: '升级' },
      { value: 4, title: '降级' },
      { value: 5, title: '补偿续费' },
      { value: 6, title: '退款' }
    ],
    orderStatusArr: [
      { value: 0, title: '订单待确认' },
      { value: 1, title: '商家已确认' },
      { value: 2, title: '交易成功' },
      { value: -1, title: '交易关闭' }
    ],
    payTypeArr: [
      { value: 1, title: '现款现货' },
      { value: 2, title: '货到付款' },
      { value: 3, title: '月结货款' },
      { value: 4, title: '预付费' },
      { value: 5, title: '后付费' }
    ],
    paymentTypeArr: [
      { value: 1, title: '对公转账' },
      { value: 2, title: '微信支付' },
      { value: 3, title: '余额支付' },
      { value: 4, title: '微信收款码' },
      { value: 100, title: '其他' }
    ],
    payStatusArr: [
      { value: 0, title: '待付款' },
      { value: 2, title: '付款中' },
      { value: 1, title: '已支付' },
      { value: -1, title: '交易关闭' }
    ],
    shippingStatusArr: [
      { value: 0, title: '待发货' },
      { value: 1, title: '待揽收' },
      { value: 2, title: '在途中' },
      { value: 3, title: '已签收' }
    ],
    invoiceTypeArr: [
      { value: 1, title: '普通发票' },
      { value: 2, title: '增值税普通发票' },
      { value: 3, title: '增值税专用发票' },
      { value: 4, title: '增值税电子普通发票' },
      { value: 5, title: '增值税电子专用发票' }
    ],
    orderInvoiceStatusArr: [
      { value: 1, title: '开票中' },
      { value: 2, title: '已开具' },
      { value: 3, title: '退票中' },
      { value: 4, title: '已作废' },
      { value: 5, title: '已红冲' },
      { value: 6, title: '作废中' }
    ],
    billTypeArr: [
      { value: 1, title: '月结账单' }
    ],
    billFlowTypeArr: [
      { value: 1, title: '增值收入' },
      { value: 2, title: '订单消费' },
      { value: 3, title: '账户充值' },
      { value: 4, title: '账户提现' }
    ],
    abnormalTypeArr: [
      { value: 'access_abnormal', title: '接入异常' },
      { value: 'collection_abnormal', title: '采集异常' },
      { value: 'response_abnormal', title: '响应异常' },
      { value: 'sim_abnormal', title: '物联卡异常' }
    ],
    reasonCodeArr: [
      { value: 'ap_auto_disable', title: '自动停用' },
      { value: 'ap_manual_disable', title: '手动停用' },
      { value: 'dtu_config_error', title: '配置异常' },
      { value: 'wifi_unconfigured', title: 'WIFI未配网' },
      { value: 'power_down', title: '长期离线' },
      { value: 'dev_unload', title: '未加载模型' },
      { value: 'dev_no_cmd', title: '模型无指令' },
      { value: 'no_response', title: '无响应' },
      { value: 'no_response_partially', title: '部分响应' },
      { value: 'high_freq_error_data_report', title: '超频上报' },
      { value: 'sim_flow_exhaustion_stop', title: '卡达量停用' },
      { value: 'sim_rebind_stop', title: '卡换绑停用' },
      { value: 'sim_manual_stop', title: '卡主动停用' },
      { value: 'sim_other_stop', title: '卡其他停用' },
      { value: 'sim_outage', title: '卡停机' },
      { value: 'sim_deleted', title: '卡销户' },
      { value: 'sim_card_damaged', title: '卡损坏' },
      { value: 'sim_flow_not_enough', title: '流量过快' },
      { value: 'sim_flow_exceeded', title: '流量超限' },
      { value: 'sim_mismatched', title: '机卡不匹配' },
    ],
  },
  mutations: {
  },
  actions: {
  }
}

export default expenseStore
